import React, { useState, useEffect } from "react"
import useToast from "../../../hooks/useToast.hook"
import InputNumberConfirmForm, {
  INPUT_NUMBER_CONFIRM_FORM_MODES,
} from "../../../components/molecules/InputConfirmNumber.form.molecule"
import { KEYBOARD_ACTIONS } from "../../../consts/keyBoard.consts"

const DEFAULT_INPUT_PROPS = {
  min: 0,
  maxFractionDigits: 0,
  useGrouping: false,
  step: 1,
}

const EditNumberTemplate = ({
  value,
  onClose,
  onBlur,
  onComplete = () => {},
  inputProps = {},
  allowSameValue = false,
}) => {
  const [currentValue, setCurrentValue] = useState(value)
  const [originalValue, setOriginalValue] = useState(value)
  const [submitting, setSubmitting] = useState(false)
  useEffect(() => {
    setCurrentValue(value)
    setOriginalValue(value)
  }, [value])
  const { setErrorMessage } = useToast()
  const isError =
    currentValue === "" ||
    currentValue === null ||
    currentValue === undefined ||
    currentValue === 0
  inputProps = {
    ...DEFAULT_INPUT_PROPS,
    ...inputProps,
  }
  const error =
    isError ?
      [
        {
          errorMessage: "El campo no puede estar vacío",
        },
      ]
    : []
  const onConfirm = async () => {
    setSubmitting(true)
    try {
      if (currentValue === originalValue && !allowSameValue) {
        throw new Error("No se han realizado cambios")
      }
      let value = currentValue
      if (inputProps.min && value < inputProps.min) {
        value = inputProps.min
      }
      onClose()
      setTimeout(() => {
        onComplete(value)
      }, 0)
    } catch (error) {
      setErrorMessage({ message: error.message })
    } finally {
      setSubmitting(false)
    }
  }
  return (
    <InputNumberConfirmForm
      className="edit-number-template"
      value={currentValue ? parseFloat(currentValue) : ""}
      onChange={({ value }) => {
        value = parseFloat(value, 10)
        if (inputProps.max && value > inputProps.max) {
          value = inputProps.max
        }
        setCurrentValue(value)
      }}
      onKeyDown={(e) => {
        if (e.key === KEYBOARD_ACTIONS.ENTER && !isError) {
          e.preventDefault()
          e.stopPropagation()
          onConfirm()
        } else if (e.key === KEYBOARD_ACTIONS.ENTER && isError) {
          e.preventDefault()
          e.stopPropagation()
          setErrorMessage({ message: error[0].errorMessage })
        } else if (e.key === KEYBOARD_ACTIONS.ESCAPE) {
          e.preventDefault()
          e.stopPropagation()
          onBlur()
        }
      }}
      onBlur={() => {
        if (submitting) return
        setCurrentValue(originalValue)
        onBlur()
      }}
      disabled={submitting}
      disableConfirmButton={
        submitting || (currentValue === originalValue && !allowSameValue)
      }
      onConfirm={onConfirm}
      error={error}
      min={0}
      max={inputProps.max}
      maxLength={
        inputProps.max?.toString().length + inputProps.maxFractionDigits || null
      }
      maxFractionDigits={inputProps.maxFractionDigits}
      withoutErrorMessage
      numberTime
      autoFocus
      useGrouping={inputProps.useGrouping}
      step={inputProps.step}
      mode={INPUT_NUMBER_CONFIRM_FORM_MODES.ATTACHED}
    />
  )
}

export default EditNumberTemplate
